module.exports = __webpack_public_path__ + "static/media/steps.fd521524.svg";